import {
  FaHtml5,
  FaCss3Alt,
  FaJsSquare,
  FaReact,
  FaGitAlt,
  FaNodeJs,
  FaBrain,
} from "react-icons/fa";
import {
  SiTailwindcss,
  SiMysql,
  SiTypescript,
  SiPython,
  SiLinux,
} from "react-icons/si";

const skillsWithIcons = [
  { name: "HTML", icon: <FaHtml5 color="#E34F26" /> },
  { name: "CSS", icon: <FaCss3Alt color="#1572B6" /> },
  { name: "JavaScript", icon: <FaJsSquare color="#F7DF1E" /> },
  { name: "React", icon: <FaReact color="#61DAFB" /> },
  { name: "TypeScript", icon: <SiTypescript color="#3178C6" /> },
  { name: "Tailwind", icon: <SiTailwindcss color="#06B6D4" /> },
  { name: "Git & GitHub", icon: <FaGitAlt color="#F05032" /> },
  { name: "Node.js", icon: <FaNodeJs color="#339933" /> },
  { name: "MySQL", icon: <SiMysql color="#4479A1" /> },
  { name: "Python", icon: <SiPython color="#3776AB" /> },
  {
    name: "Machine Learning (specialization in progress)",
    icon: <FaBrain color="#fb923c" />,
  },
  {
    name: "Linux for Development",
    icon: <SiLinux color="#facc15" />,
  },
];

const Skills = () => {
  return (
    <section id="skills" className="section">
      <h2>Skills</h2>
      <div className="skills-container">
        {skillsWithIcons.map((skill, index) => (
          <div key={index} className="skill-card">
            <span className="skill-icon">{skill.icon}</span>
            <span className="skill-name">{skill.name}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
